module.exports = __webpack_public_path__ + "3ad2b78bf994a47706f13b96223262b4.svg";